import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectUser } from '@batical/reducer/src'

const CGU_VER = Number(import.meta.env.VITE_CGU_VERSION ?? 3)

/** Redirige vers l’écran d’acceptation CGU tant que le profil RTDB n’a pas la version courante. */
export function RequireCguAccept({ children }: { children: ReactNode }) {
  const user = useSelector(selectUser)
  const { pathname } = useLocation()

  if (pathname.includes('CGUAccept')) {
    return <>{children}</>
  }

  if (user.id && user.cguVersionSigned !== CGU_VER) {
    return <Navigate to="/dashboard/CGUAccept" replace />
  }

  return <>{children}</>
}
